module.exports = __webpack_public_path__ + "static/media/huawei.b7a3a132.png";